import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Paper,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface PhysicalDataProps {
  data: {
    dimensions: {
      height: string;
      length: string;
      width: string;
      dryWeight: string;
      operatingWeight: string;
    };
    clearances: {
      leftSide: string;
      rightSide: string;
      front: string;
      rear: string;
      top: string;
    };
  };
  onChange: (subSection: string, field: string, value: string) => void;
}

const PhysicalDataSection: React.FC<PhysicalDataProps> = ({ data, onChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h5">4. Physical Data</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2">
            See Appendix A for details on which dimension is which.
          </Typography>
        </Box>

        {/* Dimensions Section */}
        <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>Dimensions</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Height"
                value={data.dimensions.height}
                onChange={(e) => onChange('dimensions', 'height', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Length"
                value={data.dimensions.length}
                onChange={(e) => onChange('dimensions', 'length', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Width"
                value={data.dimensions.width}
                onChange={(e) => onChange('dimensions', 'width', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Dry Weight"
                value={data.dimensions.dryWeight}
                onChange={(e) => onChange('dimensions', 'dryWeight', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[kg]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                label="Operating Weight"
                value={data.dimensions.operatingWeight}
                onChange={(e) => onChange('dimensions', 'operatingWeight', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[kg]"
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Clearances Section */}
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>Clearances</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Left Side"
                value={data.clearances.leftSide}
                onChange={(e) => onChange('clearances', 'leftSide', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Right Side"
                value={data.clearances.rightSide}
                onChange={(e) => onChange('clearances', 'rightSide', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Front"
                value={data.clearances.front}
                onChange={(e) => onChange('clearances', 'front', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Rear"
                value={data.clearances.rear}
                onChange={(e) => onChange('clearances', 'rear', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Top"
                value={data.clearances.top}
                onChange={(e) => onChange('clearances', 'top', e.target.value)}
                fullWidth
                margin="normal"
                className="blue-highlight"
                size="small"
                helperText="[mm]"
              />
            </Grid>
          </Grid>
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
};

export default PhysicalDataSection;